export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

export async function api<T = any>(path: string, opts: { method?: string; body?: any } = {}): Promise<T> {
  const res = await fetch(path, {
    method: opts.method || "GET",
    headers: opts.body !== undefined ? { "Content-Type": "application/json" } : undefined,
    body: opts.body !== undefined ? JSON.stringify(opts.body) : undefined,
    credentials: "same-origin",
  });
  if (res.status === 401 && !path.startsWith("/api/auth/login")) {
    location.hash = "#/login";
    throw new ApiError(401, "Not logged in");
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new ApiError(res.status, (data && data.detail) || `HTTP ${res.status}`);
  }
  return data as T;
}

export function fmtDuration(totalSeconds: number): string {
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = Math.floor(totalSeconds % 60);
  if (h > 0) return `${h}h ${String(m).padStart(2, "0")}m`;
  if (m > 0) return `${m}m ${String(s).padStart(2, "0")}s`;
  return `${s}s`;
}

export function fmtDate(unixSeconds: number | null): string {
  if (!unixSeconds) return "–";
  return new Date(unixSeconds * 1000).toLocaleString();
}

const euro = new Intl.NumberFormat(undefined, { style: "currency", currency: "EUR" });

export function fmtEuro(cents: number): string {
  return euro.format(cents / 100);
}

/** Decimal hours for pay contexts ("13.16 h"), next to fmtDuration's "13h 09m". */
export function fmtHours(totalSeconds: number): string {
  return `${(totalSeconds / 3600).toFixed(2)} h`;
}

/** "2026-09" → "September 2026" in the browser's locale. */
export function fmtMonth(ym: string): string {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString(undefined, { month: "long", year: "numeric" });
}
